import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react/components/shared/TippyV2";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export interface MobileSpaceSettingsButtonProps {
  onClick: () => void;
}

export const MobileSpaceSettingsButton = ({
  onClick,
}: MobileSpaceSettingsButtonProps) => (
  <TippyV2 content={t("space_settings")}>
    <IconButton
      onClick={onClick}
      name="20-menu-dots-horizontal"
      iconSize={20}
      buttonSize={36}
      ariaLabel={t("space_settings")}
      className="rounded-lg"
    />
  </TippyV2>
);
